import { render, staticRenderFns } from "./detailTimeline.vue?vue&type=template&id=23ed3050"
import script from "./detailTimeline.vue?vue&type=script&lang=js"
export * from "./detailTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports